import type { CDescriptivePageTranslations } from "./pl";

export const de: CDescriptivePageTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  emptyContent: "Diese Seite enthält noch keinen Inhalt.",
};
